import { render, staticRenderFns } from "./LocalStorage.vue?vue&type=template&id=59380692"
import script from "./LocalStorage.vue?vue&type=script&lang=js"
export * from "./LocalStorage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports